import {observer} from "mobx-react-lite";


export const Settings = observer(() => {

    return (
        <div>
            Settings
        </div>
    )
})